import { userRoles } from "./roles";

const constants = {
  app: {
    baseURL: "https://api.vruksha.alpha-03.trizentinc.com",
    renderFile:
      "https://api.vruksha.alpha-03.trizentinc.com/files/download",
  },
};

export { constants, userRoles };
